import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, AlertController } from 'ionic-angular';
import { StepformPage } from '../stepform/stepform';
import { ViewContactPage } from '../view-contact/view-contact';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';

@IonicPage()
@Component({
  selector: 'page-thankyou',
  templateUrl: 'thankyou.html',
})
export class ThankyouPage {

  public contact_type: any;
  public email: any;
  public uid: any;
  public contact_uid: any;
  public primary_uid: any;
  public secondary_uid: any;
  public CT : any;
  public CSC : any;
  public check_deleted: number;
  public pc_UID : any;
  public sc_UID : any;


  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public viewCtrl : ViewController,
    public db: AngularFirestore,
    public alertCtrl: AlertController
  ) {
    this.contact_type = window.localStorage.getItem("contact_second_uid");
    this.contact_uid = window.localStorage.getItem("contact_uid");

    let thiss = this;
    this.email = window.localStorage.getItem("email");
    this.uid = window.localStorage.getItem("uid");

    var docRef = firebase.firestore().collection("users").doc(this.uid);
    thiss.check_deleted  = 0;
    docRef.get().then(function(doc) {
      if (doc.exists) {
        //let user_data = doc.data();
        thiss.getContactDetails().subscribe((data)=>{
          if(data[0].contact_type == "Primary Contact"){
            thiss.primary_uid = data[0].secondary_contact_uid;
            thiss.CT = 'SECONDARY';
            thiss.pc_UID = thiss.contact_uid;
            thiss.sc_UID = data[0].secondary_contact_uid;
            if(thiss.primary_uid == null || thiss.primary_uid == undefined || thiss.primary_uid == ""){
              thiss.CSC = 'SECONDARY';
            }else{
              thiss.getContactDetailss(thiss.primary_uid).subscribe((data1)=>{
                if(data1[0].deleted == 1){
                  thiss.check_deleted  = 1;
                }
              });
            }
          }else{
            thiss.primary_uid = data[0].main_contact_uid;
            thiss.sc_UID = thiss.contact_uid;
            thiss.CT = 'PRIMARY';
            thiss.pc_UID = data[0].main_contact_uid;
          }
        });
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });
  }

  ionViewDidLoad() {
  }

  getContactDetails (){
    return this.db.collection<any>( "users" , ref => ref.where('roles.contact','==',true ).where('uid','==',this.contact_uid )).valueChanges ();
  }

  getContactDetailss (primary_uid){
    return this.db.collection<any>( "users" , ref => ref.where('roles.contact','==',true ).where('uid','==',primary_uid )).valueChanges ();
  }

  gotoSecondarypage(){
    if(this.CSC == "SECONDARY"){
      window.localStorage.setItem("creating_second", 'yes');
      this.primary_uid = null;
    }else{
      window.localStorage.removeItem("creating_second");
    }
    this.navCtrl.push(StepformPage,{
      edit_contact_uid:this.primary_uid
    });
  }

  gotoAddRealEstate(){
    window.localStorage.setItem("contact_uid", this.pc_UID);
    if(this.sc_UID == "" || this.sc_UID == null || this.sc_UID == undefined){}else{
      window.localStorage.setItem("contact_second_uid", this.sc_UID);
    }
    window.localStorage.removeItem("creating_second");
  }

  gotoSkip(){
    this.navCtrl.push(ViewContactPage);
  }

  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }

  doClick(){
    this.viewCtrl.dismiss();
  }

  deletedContactPopup(event){
    let alert = this.alertCtrl.create({
      title: 'Message',
      message: 'Please contact admin to restore this “Contact”.',
      buttons: [
          {
              text: 'OK',
              handler: () => {
                  console.log('Cancel clicked');
              }
          }
      ]
    });
    alert.present();    
  }

}



// WEBPACK FOOTER //
// ./src/pages/thankyou/thankyou.ts